<template>
    <div name="20230314" class="agree">
        <strong>솔닥 개인정보의 수집·이용 동의서[의료기관용]</strong><br/>
        <br/>
        솔닥 주식회사는 비대면 진료 서비스 제공을 위하여 아래와 같이 의료기관의 개인정보를 수집ᆞ이용하고자 합니다.<br/>내용을 자세히 읽으신 후 동의 여부를 결정하여 주세요.<br/>
        <br/>
        개인정보 수집ᆞ이용<br/>
        <table style="width: 911px;" class="table">
            <thead>                
                <th style="width: 20%"><strong>수집</strong><strong>ᆞ</strong><strong>이용 목적&nbsp;</strong></th>            
                <th style="width: 290.078px;"><strong>항목</strong>&nbsp;</th>            
                <th style="width: 243.922px;">&nbsp;<strong>보유ᆞ이용기간</strong></th>            
            </thead>
            <tbody>
                <tr style="height: 123px;">
                <td style="width: 292px; height: 123px;">&nbsp;회원가입 및 관리</td>
                <td style="width: 290.078px; height: 123px;">아이디, 비밀번호, 대표자 이름, 대표자 이메일, 계좌번호 및 통장 사본, 의료진 이름, 전문 분야, 진료과, 근무처 정보(병원/약국명, 주소, 연락처), 면허 번호, 면허증 사본, 학력, 경력, 진료과목, 배달가능과목, 요양기관번호, 사업자등록번호, 암호화된 동일인 식별정보(CI), 중복가입 확인정보(DI)&nbsp;</td>
                <td style="width: 243.922px; height: 123px;">&nbsp;개인정보 처리방침에 따라 이용자의 이용계약 해지(회원 탈퇴) 시까지</td>
                </tr>
                <tr style="height: 48.5px;">
                <td style="width: 292px; height: 48.5px;">&nbsp;서비스 제공에 관한 계약 이행 및 요금 정산</td>
                <td style="width: 290.078px; height: 48.5px;">&nbsp;정산용 계좌번호, 통장 사본</td>
                <td style="width: 243.922px; height: 48.5px;">&nbsp;개인정보 처리방침에 따라 이용자의 이용계약 해지(회원 탈퇴) 시까지</td>
                </tr>
                <tr style="height: 66px;">
                <td style="width: 292px; height: 66px;">&nbsp;신규 서비스 개발 및 마케팅, 광고 제공</td>
                <td style="width: 290.078px; height: 66px;">&nbsp;전문 분야, 진료과, 진료 희망 분야</td>
                <td style="width: 243.922px; height: 66px;">&nbsp;개인정보 처리방침에 따라 이용자의 이용계약 해지(회원 탈퇴) 시까지</td>
                </tr>
                <tr style="height: 112px;">
                <td style="width: 292px; height: 112px;">&nbsp;기타 문의, 서비스 요청에 대한 응대 및 처리</td>
                <td style="width: 290.078px; height: 112px;">&nbsp;서비스 이용기록, 접속 기기 정보, 접속로그, 접속 IP 정보, 쿠키, 방문 일시, 불량 이용 기록, 광고식별자, 사용 이동통신사, 상담 내역</td>
                <td style="width: 243.922px; height: 112px;">&nbsp;개인정보 처리방침에 따라 이용자의 이용계약 해지(회원 탈퇴) 시까지</td>
                </tr>
            </tbody>
        </table><br/>
        <br/>
        ※	위의 개인정보 수집ᆞ이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우, 솔닥 비대면 진료 서비스 이용에 제한을 받을 수 있습니다.<br/>
    </div>
</template>

<script>
export default {
    name: '20230314'
}
</script>

<style scoped>
    .agree{
        padding: 20px;
        padding-top: 40px;
        background: #FFFFFF;
    }
</style>


// WEBPACK FOOTER //
// src/pages/partners/contents/use/center/20230314.vue